import { serializeToJson } from "@/functional/datetimehelper";
import { AsyncRestClient } from "@/infrastructure/backend/async/AsyncRestClient"
import { deepClone } from "@/infrastructure/functional/deepClone";
import { CreateUserError, ErrorStateServiceForRoot } from "@/infrastructure/observables/errorState"



export type ChangePasswordData = {
    id: number
    kennwort?: string
    kennwortNeu?: string
    kennwortVergleich?: string
    userId?: string
}
export class KennwortVerwaltung {

    public async changePassword(data: ChangePasswordData): Promise<boolean> {
        const request = serializeToJson(data)                
        let client = AsyncRestClient.Create(true);
        if (client.isFailure) return false;
        const result = await client
            .getValue()
            .exchangeForComponents<string, any>(process.env.VUE_APP_API + "api/benutzer/changePassword" , request);
        if (result.isFailure) return false;        
        var saveResult = deepClone( result.getValue())
        if( saveResult.isError) {
            const errorState = ErrorStateServiceForRoot.getErrorStateService()                                  
            errorState.changeErrorState(CreateUserError("Password.Change" , saveResult.error))                
            return false;
        }
        return true
    }

    public async changePasswordByAdmin(data: ChangePasswordData): Promise<boolean> {
        const request = serializeToJson(data)                
        let client = AsyncRestClient.Create(true);
        if (client.isFailure) return false;
        const result = await client
            .getValue()
            .exchangeForComponents<string, any>(process.env.VUE_APP_API + "api/benutzer/changePasswordByAdmin" , request);
        if (result.isFailure) return false;
        var saveResult = deepClone( result.getValue())
        if( saveResult.isError) {
            const errorState = ErrorStateServiceForRoot.getErrorStateService()                                  
            errorState.changeErrorState(CreateUserError("Password.ChangeByAdmin" , saveResult.error))                
            return false;
        }
        return true
    }


    public async newPassword(data: ChangePasswordData): Promise<boolean> {
        const request = serializeToJson(data)                
        let client = AsyncRestClient.Create(true);
        if (client.isFailure) return false;
        const result = await client
            .getValue()
            .exchangeForComponents<string, any>(process.env.VUE_APP_API + "api/benutzer/newPassword" , request);
        if (result.isFailure) return false;
        var saveResult = deepClone( result.getValue())
        if( saveResult.isError) {
            const errorState = ErrorStateServiceForRoot.getErrorStateService()                                  
            errorState.changeErrorState(CreateUserError("Password.New" , saveResult.error))                
            return false;
        }
        return true
    }

}